import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from 'framer-motion';
import {
    ANIMATION_BIGGER,
    ANIMATION_SMALLER,
    conditionalScaleAnimation
} from 'libs/styles/animations';
import { EColors, EFonts } from 'libs/styles/styling';
import { useState } from 'react';
import styled from 'styled-components/macro';
import { useUpdateEffect } from 'usehooks-ts';

interface Props {
    value?: boolean;
    label: string;
    onChange?: (value: boolean) => void;
    className?: string;
}

export const CheckValue = (props: Props): JSX.Element => {
    const [value, setValue] = useState<boolean>(props.value ?? false);

    useUpdateEffect(() => {
        setValue(props.value);
    }, [props.value]);

    return (
        <S_CheckValue>
            <motion.div {...conditionalScaleAnimation(true, ANIMATION_BIGGER, ANIMATION_SMALLER)}>
                <S_Checkbox
                    className={props.className}
                    $selected={value}
                    onClick={() => {
                        props.onChange?.(!value);
                    }}
                >
                    {value && <S_CheckboxInner icon={['fas', 'circle-check']} />}
                </S_Checkbox>
            </motion.div>
            <S_Label>{props.label}</S_Label>
        </S_CheckValue>
    );
};

const S_CheckValue = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

const S_Checkbox = styled.div<{ $selected: boolean }>`
    border-radius: 100%;
    border: 1px solid #dadada;
    background: #f5f5f5;
    box-shadow: 0px 0px 20px 0px #dedede inset;
    padding: 2px;
    display: flex;
    width: 25px;
    height: 25px;
    cursor: pointer;
    align-items: center;
    justify-content: center;
`;

const S_CheckboxInner = styled(FontAwesomeIcon)`
    font-size: 22px;
    color: ${EColors.DARK};
`;

const S_Label = styled.div`
    color: #141c54;
    font-size: 13px;
    padding-left: 15px;
    font-family: ${EFonts.Regular};
`;
